import React from 'react';
import { bool, func, string } from 'prop-types';

import ImageSystemMaintenance from '@assets/Image/DayTrading/SystemMaintenance.svg';

import { Container, Button, Typography } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

const PopUpDtSuspended = (props) => {
  const { message, show, onHide } = props;

  return (
    <PopUpCenterV2 size="md" show={show} onHide={onHide} data-testid="popup-dtMaintenance">
      <img src={ImageSystemMaintenance} alt="account-suspended" />
      <Container padding="8px 48px 32px">
        <Typography type="body" bold align="center" margin={0}>
          Sistem Dalam Pemeliharaan
        </Typography>
        <Typography type="body" align="center" marginTop={8}>
          {message}
        </Typography>
      </Container>
      <Button fluid variant="primary" size="lg" onClick={onHide}>
        Kembali
      </Button>
    </PopUpCenterV2>
  );
};

PopUpDtSuspended.propTypes = {
  message: string,
  show: bool,
  onHide: func,
};

PopUpDtSuspended.defaultProps = {
  message: '',
  show: false,
  onHide: () => {},
};

export default PopUpDtSuspended;
